import { render, staticRenderFns } from "./LoginMain.vue?vue&type=template&id=3a184b1d&scoped=true"
import script from "./LoginMain.vue?vue&type=script&lang=js"
export * from "./LoginMain.vue?vue&type=script&lang=js"
import style0 from "./LoginMain.vue?vue&type=style&index=0&id=3a184b1d&prod&lang=sass&scoped=true"
import style1 from "./LoginMain.vue?vue&type=style&index=1&id=3a184b1d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a184b1d",
  null
  
)

export default component.exports